import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_DOCTOR_NAME_API, RQ_GET_INPUT_DISTRIBUTION_REPORT_API, RQ_GET_INPUT_NAME_API} from '@app/reactQuery/apis/constants';

export const RQUseGetInputDistributionReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_input_distribution_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, entityTagId, inputTypeId, inputNameId, doctorNameId, startDate, endDate, doctorUniqueCode} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_INPUT_DISTRIBUTION_REPORT_API,
        null,
        certificate,
        {divisionId: divisionId,
          startDate:startDate, endDate: endDate, entityTagId: entityTagId, inputTypeId: inputTypeId, inputNameId: inputNameId, doctorNameId: doctorNameId, doctorUniqueCode:doctorUniqueCode},
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetInputNameData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_input_name_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, inputTypeId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_INPUT_NAME_API,
        null,
        certificate,
        {
          locationId: locationId,
          inputTypeId: inputTypeId,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetDoctorNameData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_doctor_name_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_DOCTOR_NAME_API,
        null,
        certificate,
        {
          locationId: locationId,
        },
        signal,
      );
    },
    ...options,
  });
};
